import { MutationTree } from "vuex";
import { Recipes } from "@/types/recipes";
import { TagGroups } from "@/types/search";
import {
  PantryState,
  PantryList,
  PantryDetail,
  PantryPlateDetail,
  PantryConsumeFoods,
  PantryPlateSettingWeightInfo,
  PantryFridgeListInfo,
  RecognitionCandidate,
  PantryFridgeDetail,
  RecipeFoods,
  RecipeFoodMap,
  RankingFoods,
  FavoriteFoods,
  MenuCategories,
  PurChasedFoods,
  RecognitionCandidateMap,
  PlateDeviceMode,
  FoodRecommendationList,
  PantryItemsConsumeFoodList,
  FavoriteFoodStatus,
  FridgeItemsJudge,
  SaveAddFoodItemData,
  SaveDeleteFoodItemData,
  CameraImageItem,
  CameraImageMap,
  CameraImageUrlItem,
  CameraImageUrlMap
} from "@/types/pantry";
import NativeClient from "@/client/native-client";
import { Products } from "@/types/common";
import CommonUtil from "@/utils/common-utils";
import e from "express";

const mutations: MutationTree<PantryState> = {
  updateTagGroups: (state, tagGroups: TagGroups | null) => {
    state.tagGroups = tagGroups;
  },
  updateSearchRecipes: (state, searchRecipes: Recipes | null) => {
    state.searchRecipes = searchRecipes;
  },
  updateRecommendRecipes: (state, recommnedRecipes: Recipes | null) => {
    state.recommendRecipes = recommnedRecipes;
  },
  updatePantryList: (state, pantryList: PantryList | null) => {
    const totalCount = (pantryList != null) ? pantryList.totalCount : 0;
    const listCount = (pantryList != null) ? pantryList.pantryList.length : 0;
    NativeClient.sendDebugLog(
      "[Paging]mutation pantryList totalCount=" + totalCount + " listCount=" + listCount
    );
    state.pantryList = pantryList;
  },
  updatePantryVirtualList: (state, pantryVirtualList: PantryList | null) => {
    const totalCount = (pantryVirtualList != null) ? pantryVirtualList.totalCount : 0;
    const listCount = (pantryVirtualList != null) ? pantryVirtualList.pantryList.length : 0;
    NativeClient.sendDebugLog(
      "[Paging]mutation updatePantryVirtualList totalCount=" + totalCount + " listCount=" + listCount
    );
    state.pantryVirtualList = pantryVirtualList;
  },
  updatePantryDetail: (state, pantryDetail: PantryDetail | null) => {
    state.pantryDetail = pantryDetail;
  },
  updatePantryPlateDetail: (
    state,
    pantryPlateDetail: PantryPlateDetail | null
  ) => {
    state.pantryPlateDetail = pantryPlateDetail;
  },
  updatePantryConsumeFoods: (
    state,
    pantryConsumeFoods: PantryConsumeFoods | null
  ) => {
    state.pantryConsumeFoods = pantryConsumeFoods;
  },
  updatePantryPlateSettingWeight: (
    state,
    pantryPlateSettingWeight: PantryPlateSettingWeightInfo | null
  ) => {
    state.pantryPlateSettingWeight = pantryPlateSettingWeight;
  },
  updatePantryFridgeListInfo: (
    state,
    pantryFridgeListInfo: PantryFridgeListInfo | null
  ) => {
    state.pantryFridgeListInfo = pantryFridgeListInfo;
  },
  updateRecognitionCandidateMap: (
    state,
    data: RecognitionCandidate | null
  ) => {
    if (data == null) {
      if (state.recognitionCandidateMap != null) {
        state.recognitionCandidateMap.map.clear();
        state.recognitionCandidateMap = null;
      }
      NativeClient.sendDebugLog("Pantry_Mulations.ts updatePantryFridgeRecognitionCandidate state.recognitionCandidateMap = null");
    } else {
      if (state.recognitionCandidateMap == null) {
        state.recognitionCandidateMap = new RecognitionCandidateMap();
      }
      if (data.inferenceResultFoodId != null) {
        state.recognitionCandidateMap.map.set(data.inferenceResultFoodId, data);
      }
      NativeClient.sendDebugLog("Pantry_Mulations.ts updatePantryFridgeRecognitionCandidate state.recognitionCandidateMap size=" + state.recognitionCandidateMap.map.size);
    }
  },
  updatePantryFridgeDetail: (
    state,
    pantryFridgeDetail: PantryFridgeDetail | null
  ) => {
    state.pantryFridgeDetail = pantryFridgeDetail;
  },
  updateRecipeFoods: (state, recipeFoods: RecipeFoods | null) => {
    state.recipeFoods = recipeFoods;
  },
  updateRecipeFoodMap: (state, recipeFoods: RecipeFoods | null) => {
    if (recipeFoods == null) {
      if (state.recipeFoodMap != null) {
        state.recipeFoodMap.map.clear();
        state.recipeFoodMap = null;
      }
    } else {
      if (state.recipeFoodMap != null) {
        state.recipeFoodMap.map.clear();
        state.recipeFoodMap = null;
      }
      state.recipeFoodMap = new RecipeFoodMap(recipeFoods);
    }
  },
  updateUsedUpPantryList: (state, usedUpPantryList: PantryList | null) => {
    state.usedUpPantryList = usedUpPantryList;
  },
  updateRankingFoods: (state, rankingFoods: RankingFoods | null) => {
    state.rankingFoods = rankingFoods;
  },
  updateFavoriteFoods: (state, favotiteFoods: FavoriteFoods | null) => {
    state.favotiteFoods = favotiteFoods;
  },
  updateMenuCategories: (state, menuCategoies: MenuCategories | null) => {
    state.menuCategoies = menuCategoies;
  },
  updatePurChasedFoods: (state, purChasedFoods: PurChasedFoods | null) => {
    state.purChasedFoods = purChasedFoods;
  },
  updateProducts: (state, products: Products | null) => {
    state.products = products;
  },
  updatePlateDeviceMode: (state, plateDeviceMode: PlateDeviceMode | null) => {
    state.plateDeviceMode = plateDeviceMode;
  },
  updateFoodRecommendationList: (state, foodRecommendationList: FoodRecommendationList | null) => {
    state.foodRecommendationList = foodRecommendationList;
  },
  updateFoodConsumeList: (state, list: PantryItemsConsumeFoodList | null) => {
    state.foodConsumeList = list;
  },
  updateFavoriteFood: (state, status: FavoriteFoodStatus | null) => {
    state.favoriteFoodStatus = status;
  },
  updateFridgeItemsJudge: (state, status: FridgeItemsJudge | null) => {
    state.fridgeItemsJudge = status;
  },
  updateSaveAddFoodItems: (state, status: SaveAddFoodItemData | null) => {
    state.addFoodItems = status;
  },
  updateSaveDeleteFoodItems: (state, status: SaveDeleteFoodItemData | null) => {
    state.deleteFoodItems = status;
  },
  updateCameraImageMap: (
    state,
    data: CameraImageItem | null
  ) => {
    if (data == null) {
      if (state.cameraImageMap != null) {
        state.cameraImageMap.map.clear();
        state.cameraImageMap = null;
      }
      NativeClient.sendDebugLog("Pantry_Mulations.ts updateCameraImageMap state.cameraImageMap = null");
    } else {
      if (state.cameraImageMap == null) {
        state.cameraImageMap = new CameraImageMap();
      }
      state.cameraImageMap.map.set(data.key, data);
      NativeClient.sendDebugLog("Pantry_Mulations.ts updateCameraImageMap state.cameraImageMap size=" + state.cameraImageMap.map.size);
    }
  },
  updateCameraImageUrlMap: (
    state,
    data: CameraImageUrlItem | null
  ) => {
    if (data == null) {
      if (state.cameraImageUrlMap != null) {
        state.cameraImageUrlMap.map.clear();
        state.cameraImageUrlMap = null;
      }
      NativeClient.sendDebugLog("Pantry_Mulations.ts updateCameraImageUrlMap state.cameraImageUrlMap = null");
    } else {
      if (state.cameraImageUrlMap == null) {
        state.cameraImageUrlMap = new CameraImageUrlMap();
      }
      state.cameraImageUrlMap.map.set(data.key, data);
      NativeClient.sendDebugLog("Pantry_Mulations.ts updateCameraImageUrlMap state.cameraImageUrlMap size=" + state.cameraImageUrlMap.map.size);
    }
  }
};

export default mutations;
